(function (upp) {
    upp.directive('cartCount', [function () {
        return {
            restrict: 'A',
            replace: true,
            scope: {},
            templateUrl: require('../templates/cart-count.html'),
            controller: ['$rootScope', '$scope', '$timeout', 'cartService', function ($rootScope, $scope, $timeout, cartService) {

                var timeoutPromise = null;
                var timeout = 500; // Time to animate changes

                $scope.amount = 0;
                $scope.price = 0;
                $scope.currency = null;
                $scope.loading = false;

                var loadCartData = function(isFirstLoad) {
                    if (timeoutPromise != null)
                        $timeout.cancel(timeoutPromise); // Finish immediately previous wait timer
                    $scope.loading = true;
                    timeoutPromise = $timeout(function() {
                        return cartService.retrieveOrderList()
                            .then(function(response) {

                                if (response.data.cartIsEmpty) {
                                    $scope.amount = 0;
                                    $scope.price = 0;
                                } else {
                                    $scope.price = response.data.totalPriceWithShippingCharges;
                                    $scope.currency = response.data.currency;
                                    $scope.amount = response.data.order.reduce(function (total, product) {
                                        return total + product.selectedStock
                                    }, 0);
                                }
                            })
                            .catch(function() {
                                $scope.amount = 0;
                                $scope.price = 0;
                            })
                            .finally(function() {
                                $scope.loading = false;
                            })
                    }, isFirstLoad === true ? 0 : timeout)
                };

                var stopListening = $rootScope.$on('cart.updated', loadCartData);
                loadCartData(true);

                // De-register cart listeners
                $scope.$on('$destroy', stopListening)
            }]
        };
    }]);

}(upp));


// WEBPACK FOOTER //
// ./src/app/modules/restaurant/directives/cart-count-directive.js